import React from 'react';
import cn from 'classnames';
import { workerKeys } from '../constants';
import styles from '../WorkerCell.module.scss';

const WorkerNameBlock = ({
  name,
  speciality,
  workerKey,
  withCursor = false,
  renderIcon,
  ...props
}) => {
  return (
      <div
        {...props}
        className={cn(styles.root, {
          'dspx-ref': withCursor,
          [styles.masterName]: workerKey === workerKeys.master && name,
          [styles.masterNoName]: workerKey === workerKeys.master && !name,
          [styles.executorName]: workerKey === workerKeys.executor && name,
          [styles.executorNoName]: workerKey === workerKeys.executor && !name,
        })}
      >
        {typeof renderIcon === 'function' && renderIcon()}
        <div className={styles.nameContainer}>
          {speciality && <span className={styles.speciality}>{speciality}</span>}
          <span className={styles.name}>{name || 'не назначен'}</span>
        </div>
      </div>
  );
};

export default WorkerNameBlock;
